module.exports = __webpack_public_path__ + "img/feedback.0a78c9df.png";